export default {"src":"/_next/static/media/huhtam.35ab4370.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};